import React from "react";

import svg from "../../assets/images/icons/steps/Run Statement Rule f.svg";

export const RunStatementRuleIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Run Statement Rule"}
    />
);
